module.exports = __webpack_public_path__ + "img/618026.15939ecb.svg";